import { IndicatorProps, OptionTypeBase } from "react-select";

import IndicatorContainer from "./styled-components/IndicatorContainer";

import ClearIcon from "common/svg/ClearIcon";

function ClearIndicator({
  innerProps: { ref, ...restInnerProps },
}: IndicatorProps<OptionTypeBase, false>) {
  return (
    <IndicatorContainer {...restInnerProps} ref={ref}>
      <ClearIcon />
    </IndicatorContainer>
  );
}

export default ClearIndicator;
